import React from 'react'
import BadgeUI from '../../widgets/output/BadgeUI'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import EmptyListUI from '../../widgets/output/EmptyListUI'
import PrivatePageSF from '../../templates/PrivatePageSF.js'
import LabelAndValueUI from '../../widgets/layout/LabelAndValueUI'
import GenericErrorUI from '../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import InvoiceItemListUI from '../../components/finapp/invoice/InvoiceItemListUI'
import NameAndEditUI from '../../widgets/layout/NameAndEditUI'
import InvoiceUpdateModalSF from '../../components/finapp/invoice/InvoiceUpdateModalSF'
import InvoiceItemUpdateModalSF from '../../components/finapp/invoice/InvoiceItemUpdateModalSF'
import './InvoiceDetailPage.css'

const InvoiceDetailPageUI = ({ context, messageList, errorList, order, invoice, invoiceItemList, filteredItemList,
  searchFilter, onRefreshClick, onSearchFilterChange,
  onUpdateInvoiceClick, onCancelUpdateInvoice, onUpdateInvoiceComplete, updateInvoiceMode,
  onUpdateInvoiceItemsClick, onCancelUpdateInvoiceItems, onUpdateInvoiceItemsComplete, updateInvoiceItemsMode
}) =>
  <PrivatePageSF context={context} className='pg_invoice'
    backLink={`/orders/${order !== null ? order.customerOrderId : ''}/invoices`}
    messageList={messageList} headerMessageKey='c_invoice'
    centered={(!order || !invoice || !invoiceItemList) && !errorList}
  >
    {
      (!order || !invoice || !invoiceItemList) && !errorList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      order && invoice && invoiceItemList &&
      <React.Fragment>
        <PageTitleUI context={context} goBack={true} backLink={`/orders/${order.customerOrderId}/invoices`}
          messageList={messageList} titleMessageKey='c_invoice'
        />
        <InvoiceHeaderUI context={context} messageList={messageList} order={order} invoice={invoice}
          onUpdateClick={onUpdateInvoiceClick} updateMode={updateInvoiceMode} onCancelClick={onCancelUpdateInvoice}
          onUpdateComplete={onUpdateInvoiceComplete} />
      </React.Fragment>
    }
    {
      invoiceItemList && invoiceItemList.length === 0 &&
      <EmptyListUI
        context={context}
        messageList={messageList}
        createEnabled={context.permissions && context.permissions.includes('acc_manage')}
        onCreateClick={onUpdateInvoiceItemsClick}
        createLinkKey='c_add_inv_item'
        createDisabledMessageKey='c_no_item_msg'
      />
    }
    {
      order && invoice && invoiceItemList && filteredItemList && invoiceItemList.length !== 0 &&
      <InvoiceItemListUI
        context={context}
        invoiceItemList={filteredItemList}
        messageList={messageList}
        searchFilter={searchFilter}
        // events
        onRefreshClick={onRefreshClick}
        onSearchFilterChange={onSearchFilterChange}
        onUpdateClick={onUpdateInvoiceItemsClick}
      />
    }
    {
      order && invoice &&
      <InvoiceItemUpdateModalSF context={context} order={order} invoice={invoice}
        updateMode={updateInvoiceItemsMode} onCancelClick={onCancelUpdateInvoiceItems}
        onUpdateComplete={onUpdateInvoiceItemsComplete}
      />
    }
  </PrivatePageSF>

const InvoiceHeaderUI = ({ context, messageList, order, invoice,
  onUpdateClick, updateMode, onCancelClick, onUpdateComplete
}) =>
  <React.Fragment>
    <div className='g_flex_h'>
      <div>
        <NameAndEditUI name={invoice.invoiceName} onUpdateClick={onUpdateClick} />
        <div className='g_small'>{order.customerName}</div>
        <div className='g_small'>{order.orderName}</div>
      </div>
      <div>
        <div className='g_text_right'>
          {
            invoice.status === 'unpaid' &&
            <BadgeUI messageList={messageList} labelKey='c_status_unpaid' />
          }
          {
            invoice.status === 'paid' &&
            <BadgeUI messageList={messageList} labelKey='c_status_paid' />
          }
          {
            invoice.status === 'cancelled' &&
            <BadgeUI messageList={messageList} labelKey='c_cancelled' />
          }
        </div>
        <LabelAndValueUI messageList={messageList} labelKey='c_invoice_date' align='right'>
          {invoice.invoiceDateF1}
        </LabelAndValueUI>
      </div>
    </div>
    <div className='g_flex_h g_m_top_50'>
      <div>
        {
          invoice.status === 'unpaid' && invoice.lastSentDate &&
          <LabelAndValueUI messageList={messageList} labelKey='c_last_sent'>
            {invoice.lastSentDateF1}
          </LabelAndValueUI>
        }
        {
          invoice.status === 'paid' &&
          <LabelAndValueUI messageList={messageList} labelKey='c_status_paid'>
            {invoice.paymentDateF1}
          </LabelAndValueUI>
        }
        {
          invoice.status === 'cancelled' &&
          <LabelAndValueUI messageList={messageList} labelKey='c_cancelled'>
            {invoice.cancelDateF1}
          </LabelAndValueUI>
        }
      </div>
      <LabelAndValueUI messageList={messageList} labelKey='c_invoice_amount' align='right'>
        {invoice.invoiceAmountF2}
      </LabelAndValueUI>
    </div>

    <InvoiceUpdateModalSF context={context} invoice={invoice}
      updateMode={updateMode} onCancelClick={onCancelClick} onUpdateComplete={onUpdateComplete}
    />

  </React.Fragment>

export default InvoiceDetailPageUI
